import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

// This guard checks if the user has API_ACCESS permission
export const BulkUserUpdateGuard = () => {
  const authService = inject(AuthService);
  const router = inject(Router);
  let permissions: any;

  const authSubscription = authService.permissions$
    .subscribe((userPermissions: any) => {
      permissions = userPermissions;
    });

  // Check if user has API_ACCESS permission
  const hasApiAccess = permissions?.API_ACCESS === 1;

  if (hasApiAccess) {
    authSubscription.unsubscribe();
    return true;
  }

  authSubscription.unsubscribe();
  return router.parseUrl('/dashboard');
};
